import { useSelector } from 'react-redux';

import { selectUserToken } from '../redux/features/user/userSelectors';
import { useGetDownloadUrlMutation } from '../redux/services/documents/documentsApi';
import { handleResponseError } from '../utils/data';
import { showError } from '../utils/ui';
import { openInNewTab } from '../utils/openInNewTab';

export function useOpenDownload() {
  const userToken = useSelector(selectUserToken);
  const [getDownloadUrl] = useGetDownloadUrlMutation();

  return path =>
    openInNewTab(
      async () => (await getDownloadUrl({ token: userToken, path }).unwrap()).url,
      error => showError(handleResponseError(error))
    );
}
